import { Page } from '../../store/GeneralState/GeneralState.reducer'

const PUBLIC_PATHS = ['/', '/widerruf', '/VielenDank']
const PUBLIC_PATH_PREFIXES = ['/load/', '/customer/']

export const isPublicOrderPath = (pathname: string, availabilityPath: string): boolean => {
    if (pathname === availabilityPath || PUBLIC_PATHS.includes(pathname)) {
        return true
    }
    return PUBLIC_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix))
}

export const shouldRedirectToAvailabilityCheck = (
    pathname: string,
    zip: string,
    pagesList: Page[],
    availabilityPath: string,
): boolean => {
    if (isPublicOrderPath(pathname, availabilityPath)) {
        return false
    }
    if (zip === '') {
        return true
    }
    return !pagesList.some((page) => page.path === pathname)
}
